import React from 'react';
import { Box } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useProfile } from '../../../../customHooks/useProfile';

const CustomBox = ({ value, selected, onClick }) => {
  return (
    <Box
      sx={{
        width: '30px',
        height: '30px',
        display: 'flex',
        border: `1px solid ${!selected ? '#DDDDDD' : '#FF7676'}`,
        p: 1,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        backgroundColor: selected ? '#FF7676' : 'transparent',
        color: selected ? 'white' : '#FF7676',
      }}
      onClick={onClick}
    >
      {value}
    </Box>
  );
};

const Pagination = () => {
  const { ordercurrentPage, changeOrderPage, orderlinks, ordermeta } =
    useProfile();
  return (
    <Box sx={{ display: 'flex' }}>
      {orderlinks?.prev && (
        <CustomBox
          value={<KeyboardArrowLeftIcon />}
          onClick={() => {
            changeOrderPage(ordercurrentPage - 1);
          }}
        />
      )}
      {orderlinks?.prev && (
        <CustomBox
          value={ordermeta.current_page - 1}
          onClick={() => {
            changeOrderPage(ordercurrentPage - 1);
          }}
        />
      )}
      <CustomBox value={ordermeta?.current_page} selected={true} />
      {orderlinks?.next && (
        <CustomBox
          value={ordercurrentPage + 1}
          onClick={() => {
            changeOrderPage(ordercurrentPage + 1);
          }}
        />
      )}
      {orderlinks?.next && (
        <CustomBox
          value={<KeyboardArrowRightIcon />}
          onClick={() => {
            changeOrderPage(ordercurrentPage + 1);
          }}
        />
      )}
    </Box>
  );
};

export default Pagination;
